// src/modules/app-views/offers/pages/Document/components/OffersDocumentCardHeaderColumn3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { EditOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const OffersDocumentCardHeaderColumn3 = ({
  showUpdatedAt = true,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const updatedAt =
    (record?._metadata?.audit?.updatedAt &&
      parseDateToDisplay({ date: record._metadata.audit.updatedAt })) ||
    (record?.updatedAt && parseDateToDisplay({ date: record.updatedAt }));

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'updatedAt',
      icon: <EditOutlined />,
      label: updatedAt,
      tooltipText: translateX('last_update'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showUpdatedAt,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => i?.label && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OffersDocumentCardHeaderColumn3;
